import {UNLOCK_CHOICE_CONTROL_VARIANT, UNLOCK_CHOICE_TREATMENT_VARIANT, unlockChoiceAbTest} from "../../ab_testing/unlock_choice_ab_test";
import {IBinaryExperiment, IBinaryExperimentConfig, useBinaryExperiment} from "./use_binary_experiment";

interface IUseUnlockChoiceExperimentParams {
    isEnabled: boolean;
}

const unlockChoiceExperimentConfig: IBinaryExperimentConfig = {
    abTest: unlockChoiceAbTest,
    controlVariant: UNLOCK_CHOICE_CONTROL_VARIANT,
    treatmentVariant: UNLOCK_CHOICE_TREATMENT_VARIANT
};

/** The unlock choice modal and its payoff screens */
export const useUnlockChoiceExperiment = ({isEnabled}: IUseUnlockChoiceExperimentParams): IBinaryExperiment =>
    useBinaryExperiment(unlockChoiceExperimentConfig, {isEnabled});
import {UNLOCK_CHOICE_CONTROL_VARIANT, UNLOCK_CHOICE_TREATMENT_VARIANT, unlockChoiceAbTest} from "../../ab_testing/unlock_choice_ab_test";
import {IBinaryExperiment, IBinaryExperimentConfig, useBinaryExperiment} from "./use_binary_experiment";

interface IUseUnlockChoiceExperimentParams {
    isEnabled: boolean;
}

const unlockChoiceExperimentConfig: IBinaryExperimentConfig = {
    abTest: unlockChoiceAbTest,
    controlVariant: UNLOCK_CHOICE_CONTROL_VARIANT,
    treatmentVariant: UNLOCK_CHOICE_TREATMENT_VARIANT
};

/** The unlock choice modal and its payoff screens */
export const useUnlockChoiceExperiment = ({isEnabled}: IUseUnlockChoiceExperimentParams): IBinaryExperiment =>
    useBinaryExperiment(unlockChoiceExperimentConfig, {isEnabled});
